<template>
  <v-dialog :value="dialog" @input="$emit('update:dialog', $event)" max-width="640" scrollable>
    <v-card class="rounded-xl overflow-hidden">
      <v-toolbar flat color="primary" dark dense>
        <v-icon left small>mdi-history</v-icon>
        <v-toolbar-title class="subtitle-1 font-weight-bold">Historial de cambios</v-toolbar-title>
        <v-spacer />
        <v-btn icon small aria-label="Cerrar historial" @click="$emit('update:dialog', false)">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-2" style="max-height: 70vh">
        <HistorialLista
          v-if="dialog && idCliente"
          :idCliente="idCliente"
          :nombres="nombres"
          @ver-armario="$emit('ver-armario', $event)"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import HistorialLista from "@/components/utils/HistorialLista.vue";

// Últimos cambios en los armarios y documentos del cliente
export default {
  name: "DialogHistorialCliente",
  components: { HistorialLista },
  props: {
    dialog: { type: Boolean, default: false },
    idCliente: { type: [Number, String], default: null },
    arbol: { type: Array, default: () => [] },
  },
  computed: {
    nombres() {
      const mapa = {};
      const recorrer = (nodos) => (nodos || []).forEach((n) => { mapa[n.id] = n.name; recorrer(n.children); });
      recorrer(this.arbol);
      return mapa;
    },
  },
};
</script>
